/* eslint-disable import/no-extraneous-dependencies */
import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';

import { useDefaultStyles } from './use-default-styles';

import { getAdsLabelStyles } from './styles/ads-label';

export const AdsLabel = ({
  adsLabelText,
  styleOverrides,
}) => {
  const classes = useDefaultStyles(getAdsLabelStyles({ styleOverrides }));

  return (
    <div className={classnames('ads-label', classes.adsLabel)}>
      {adsLabelText}
    </div>
  );
};

AdsLabel.propTypes = {
  adsLabelText: PropTypes.string.isRequired,
  styleOverrides: PropTypes.shape({}),
};

AdsLabel.defaultProps = {
  styleOverrides: {},
};
